import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions,Response } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Storage } from '@ionic/storage';
import { LoadingController } from 'ionic-angular';

//service
import { AppSharedService } from '../service/app_shared';

//types
import { LoginInfo,User,FilterTypeViewmodel } from '../model/types';

@Injectable()
export class UserService{

  userDetails:User;
  filterList:FilterTypeViewmodel;

  constructor(private http : Http
              ,private storage: Storage
              ,private loadingCtrl : LoadingController
              ,private appSharedService:AppSharedService
              ,
  ) 
  { 
      this.userDetails={
            Email:"",
            CustomerName:"",
            LocationId:0,
            LocationName:"",
            Password:"",
            PostalCode:"",
            CustomerId:0,
            Contact:"",
            LocationDetails:[]
      };

      this.filterList={
        brandList:[],
        categoryList:[],
        productTypeList:[],
        vendorList:[]
      };

  }
  // get user details
  getUserDetails(){

    
        //create loader
   let loading = this.loadingCtrl.create({
          content: 'Please wait...'
  });
    
  this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {

  if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
      
    // create error
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('token', userinfo.Token);
      const options = new RequestOptions({headers: headers});

      var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlGetProfileDetails);
       
      //show loader
      loading.present();

      this.http.get(url,options)
         .subscribe((res: Response) => {   
              if(res.status==200){
                this.userDetails= JSON.parse(res.text()) as User;

                //dismiss loader
                loading.dismiss();
              }else{        

                // dismiss loader
                loading.dismiss();
              }
           });
          }
       });
    }
}



// WEBPACK FOOTER //
// ./src/pages/service/user_service.ts